import { render, staticRenderFns } from "./TeacherPageControl.vue?vue&type=template&id=04bb32b3&scoped=true&"
import script from "./TeacherPageControl.vue?vue&type=script&lang=js&"
export * from "./TeacherPageControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb32b3",
  null
  
)

export default component.exports